<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" sm="8">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4">
              <b-form @click="onRegister">
                <h1>{{ t('register_header') }}</h1>
                <p class="text-muted">{{ t('register_description') }}</p>
                <b-alert variant="danger" class="text-center" show v-if="form.register.alert.danger">{{form.register.alert.danger}}</b-alert>
                <b-alert variant="success" class="text-center" show v-if="form.register.alert.success">{{form.register.alert.success}}</b-alert>
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>@</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="text" v-model="form.register.email" class="form-control" :placeholder="t('global_email')" autocomplete="email" />
                </b-input-group>

                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="password" v-model="form.register.password1" class="form-control" :placeholder="t('global_password')" autocomplete="new-password" />
                </b-input-group>

                <b-input-group class="mb-4">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="password" v-model="form.register.password2" class="form-control" :placeholder="t('register_repeat-password')" autocomplete="new-password" />
                </b-input-group>

                <b-button variant="success" block @click="onRegister" :disabled="form.register.locked">{{ t('register_button') }}</b-button>
              </b-form>
            </b-card-body>
            <b-card-footer class="p-4">
              <b-row>
                <b-col cols="12" class="text-center">
                  <p>{{ t('register_bottom_header') }}</p>
                  <b-button block variant="primary" to="/auth/login"><span>{{ t('register_bottom_button') }}</span></b-button>
                </b-col>
              </b-row>
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'Register',
  data () {
    return {
      form: {
        register: {
          email: '',
          password1: '',
          password2: '',
          alert: {
            danger: '',
            success: ''
          },
          locked: false
        }
      }
    }
  },
  methods: {
    onRegister () {
      if (this.form.register.locked) return

      this.form.register.alert.danger = ''
      this.form.register.alert.success = ''

      const email = this.form.register.email.trim()
      const password1 = this.form.register.password1.trim()
      const password2 = this.form.register.password2.trim()

      if (email === '' || password1 === '' || password2 === '') {
        this.form.register.alert.danger = this.$translate.text('register_please-enter-your-credentials')
      } else if (password1 !== password2) {
        this.form.register.alert.danger = this.$translate.text('register_passwords-doesnt-match')
      } else {
        this.form.register.locked = true

        Vue.axios({
          method: 'POST',
          url: '/user/register',
          data: {
            email: this.form.register.email,
            password: this.form.register.password1
          },
          mode: 'no-cors',
          withCredentials: true,
          credentials: 'same-origin'
        }).then(response => {
          if (response.data.status) {
            this.form.register.alert.success = this.$translate.text('register_account-created')
          } else {
            this.form.register.alert.danger = response.data.message ? this.$translate.text(response.data.message) : this.$translate.text('global_an-unexpected-error-occurred')
            this.form.register.locked = false
          }
        }).catch(() => {
          this.form.register.alert.danger = this.$translate.text('global_an-unexpected-error-occurred')
          this.form.register.locked = false
        })
      }
    }
  }
}
</script>
